import axios from "axios";
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { Loader } from "../Components/Loader";
import { Alert } from "../Components/Modal/Alert";
import { API } from "../Services/Api";
import {
  aplicacao,
  app_base_url,
  enderecos_api,
  login_api,
} from "../Utils/Urls";
import { useEntidade } from "./EntidadeHook";

interface IUsuarioContextData {
  usuario: IUsuario;
  login(cpf: string, senha: string): Promise<void>;
  usuarioCompleto: UsuarioCompleto;
  logOut(): void;
  checarToken: () => Promise<void>;
  token: string;
}

interface IUsuarioProviderProps {
  children: ReactNode;
}

const UsuarioContext = createContext({} as IUsuarioContextData);
export const token_storage = "@usuario-iss";
function UsuarioProvider({ children }: IUsuarioProviderProps) {
  const [usuario, setUsuario] = useState({} as IUsuario);
  const [usuarioCompleto, setUsuarioCompleto] = useState({} as UsuarioCompleto);
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ titulo: "", mensagem: "" });
  const { entidade } = useEntidade();

  function saveToken() {
    localStorage.setItem(token_storage, token);
    API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    checarToken();
  }

  function logOut() {
    localStorage.removeItem(token_storage);
    setUsuario({} as IUsuario);
    setUsuarioCompleto({} as UsuarioCompleto);
  }

  function loadToken() {
    const token = localStorage.getItem(token_storage);
    // window.alert(token)
    if (token) {
      setToken(token);
    }
  }

  useEffect(() => {
    if (token) saveToken();
  }, [token]);

  useEffect(() => {
    loadToken();
  }, []);

  async function login(cpf: string, senha: string) {
    try {

      setLoading(true);
      const { data } = await API.post(`/usuario/login`, {
        banco: {
          numero: entidade.banco.substring(0, 1),
          banco: entidade.banco.replace("2-", "").replace("1-", ""),
        },
        cpf,
        senha,
      });
      if (data.status) {
        setUsuario(data.data.login[0]);
        // window.alert(data.data.token)
        setToken(data.data.token);
      } else {
        setAlert({ titulo: "Ops", mensagem: data.mensagem });
      }
    } catch (error) {
      setAlert({ titulo: "Ops", mensagem: "Não foi possível efeturar login!" });
    } finally {
      setLoading(false);
    }
  }

  async function checarToken() {
    try {
      setLoading(true);
      const { data } = await API.get(`/usuario/verifica-token`);

      //window.alert((window.location.href) + data.banco.banco)
      if (window.location.href.toLowerCase().indexOf(data.banco.banco.toLowerCase().replace("1-", "").replace("2-", "")) != -1) {
        setUsuarioCompleto(data);

        setUsuario(data.usuario);
      }





    } catch (e) {
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    //window.alert(token)
    // checarToken();
  }, [token]);

  return (
    <UsuarioContext.Provider
      value={{ logOut, usuario, login, usuarioCompleto, checarToken, token }}
    >
      <>
        {children}

        <Loader loading={loading} />
        <Alert
          alert={alert}
          onClose={() => setAlert({ titulo: "", mensagem: "" })}
          open={alert.mensagem.length > 0}
        />
      </>
    </UsuarioContext.Provider>
  );
}

function useUsuario() {
  const context = useContext(UsuarioContext);

  return context;
}

export { UsuarioProvider, useUsuario };

interface IUsuario {
  CPF: string;
  EMAIL: string;
  SENHA: string;
}

interface UsuarioCompleto {
  usuario: {
    CPF: string;
    EMAIL: string;
    SENHA: string;
  };
  banco: {
    numero: number;
    banco: string;
  };
  empresas: Empresa[];
}

export interface Empresa {
  ID: number;
  CPF: string;
  CODIGO_FIRMA: number;
  SITUACAO: string;
  CARGO: string;
  INICIO: string;
  FIM: string;
  CNPJ: string;
  TIPOUSUARIO: number;
  FANTASIA: string;
  INSCR: number;
  DIA_VENC: number;
  DESCRICAO: string;
}
